import React, { useEffect, useState } from 'react';
import {
  fetchStudents,
  deleteStudent,
  createStudent,
  updateStudent,
} from '../api/studentApi';
import StudentForm from './StudentForm';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const StudentList = () => {
  const [students, setStudents] = useState([]);
  const [editingStudent, setEditingStudent] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const loadStudents = async () => {
    const res = await fetchStudents();
    setStudents(res.data.Data);
  };

  useEffect(() => {
    loadStudents();
  }, []);

  const handleDelete = async (id) => {
    await deleteStudent(id);
    toast.success('Employee deleted successfully!');
    loadStudents();
  };

  const handleFormSubmit = async (data) => {
    if (editingStudent) {
      await updateStudent(editingStudent.S_RECID, data);
      toast.success('Employee updated successfully!');
    } else {
      await createStudent(data);
      toast.success('Employee added successfully!');
    }
    setEditingStudent(null);
    setShowModal(false);
    loadStudents();
  };

  const handleEdit = (student) => {
    setEditingStudent(student);
    setShowModal(true);
  };

  return (
    <div className="container mt-5">
      <ToastContainer />
      <h2 className="mb-4 text-center">Employee Management</h2>

      <StudentForm onSubmit={handleFormSubmit} />

      <table className="table table-bordered">
        <thead className="table-dark">
          <tr>
            <th>Name</th>
            <th>Address</th>
            <th>Education</th>
            <th style={{ width: '150px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {students.map((s) => (
            <tr key={s.S_RECID}>
              <td>{s.S_NAME}</td>
              <td>{s.S_ADDRESS}</td>
              <td>{s.S_EDUCATION}</td>
              <td>
                <button
                  className="btn btn-sm btn-warning me-2"
                  onClick={() => handleEdit(s)}
                >
                  Edit
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => handleDelete(s.S_RECID)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
          {students.length === 0 && (
            <tr>
              <td colSpan="4" className="text-center">
                No Employees found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Modal */}
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Student</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowModal(false);
                    setEditingStudent(null);
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <StudentForm
                  onSubmit={handleFormSubmit}
                  editingStudent={editingStudent}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentList;
